import { AuditEntity } from "@app/common";
import { Client, Customer } from "@app/customers-base";
import { Document } from '@app/documents-base';
import { Order, OrderItem, PhoneNumber } from "@app/orders-base";
import { ContractTerminationReason } from "../enums/contract-termination-reason";
import { ContractTerminationType } from "../enums/contract-termination-type";

export class ContractTermination extends AuditEntity {
	type: ContractTerminationType;
	reason: ContractTerminationReason;
	tariffName: string;
	externalTariffId: string;
	preferredDate: Date;
	portingOut: boolean | null;
	destinationCarrierId: string;
	wbciPrenegotiationId: string;
	comment: string;
	client: Client;
	clientId: number | null;
	customer: Customer;
	customerId: number | null;
	order: Order;
	orderId: number | null;
	mainContractId: number | null;
	orderItems: OrderItem[] = [];
	exportNumbers: PhoneNumber[];
	documents: Document[] = [];
}